import Button from './button'

const ButtonList = ({ buttons }) => {
  const base =
    'relative w-full max-w-[1060px] flex flex-wrap justify-center items-center gap-smallMobile lg:gap-x-[70px] lg:gap-y-[40px]'

  const handleClick = (identifier) =>
    document.getElementById(identifier)?.scrollIntoView({ behavior: 'smooth' })

  return (
    <div className={base}>
      {buttons.map((button, id) => (
        <Button
          key={id}
          name={button.title}
          onClick={() => handleClick(button.identifier.current)}
        />
      ))}
    </div>
  )
}

export default ButtonList
